import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CtButtonModule, CtControlModule, CtFormModule } from '@ctsolution/ct-framework';
import { TranslateModule } from '@ngx-translate/core';
import {MatLegacyDialogModule as MatDialogModule} from "@angular/material/legacy-dialog";
import { TableModule } from 'primeng/table';
import { MassiveBillingComponent } from './massive-billing.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    CtControlModule,
    FormsModule,
    ReactiveFormsModule,
    CtButtonModule,
    MatDialogModule,
    CtFormModule,
    TableModule
  ],
  declarations: [MassiveBillingComponent],
  exports: [MassiveBillingComponent]
})
export class MassiveBillingModule { }
